// ============================================================
// 基础协议命令
// ============================================================
export enum CMD_OHID {
  ohid_cmd_base_mix = 0x00, //混杂指令,用于执行一些杂项操作
  ohid_cmd_base_sync = 0x01, //获取设备的基础信息 SN和版本号等信息
  ohid_cmd_driver_param = 0x10, //获取或设置按键
  ohid_cmd_driver_mt = 0x11, //MT
  ohid_cmd_driver_tgl = 0x12, //TGL
  ohid_cmd_driver_dks = 0x13, //DKS
  ohid_cmd_driver_single = 0x1d, // 单键触发
  ohid_cmd_driver_rgb_param = 0x16, //RGB_PARAM
}

export enum OHID_MIX_ORDER {
  // 混合命令 (MIX)
  mix_order_usb_debug = 0xfe, // USB调试: arg1(uint8_t) = 开启/关闭
  mix_order_rate_test = 0xfd, // 回报率测试: arg1(uint8_t) = 开启/关闭, arg2(uint16_t) = 测试时长(ms)
  mix_order_rgb_test = 0xfc, // RGB测试: arg1(uint8_t) = 开启/关闭, arg2(uint32_t) = RGB颜色
  mix_order_key_test = 0xfb, // 按键测试: arg1(uint8_t) = 开启/关闭, arg2(uint16_t) = 按下延迟, arg3(uint8_t) = 发送间隔
  mix_order_adj_status = 0xfa, // 按键校准状态: 只读, 返回Bottom/Top值
  mix_order_query_tick = 0xf9, // 系统计时器: arg1(uint32_t) = 系统时间(ms)
  mix_order_slave_stop = 0xf8, // 停止从机通讯: arg1(uint8_t) = 停止通讯
  mix_order_adj_dead_zone = 0xf6, // 死区设置: arg1(uint8_t) = 死区(0.02mm)
  mix_order_get_axis_list = 0xf5, // 轴体类型列表: 获取支持的轴体类型
  mix_order_get_value = 0xf4, // 获取值: 获取各种值
  mix_order_set_value = 0xf3, // 设置值: 设置各种值
  mix_order_key_trigger = 0xf2, // 按键触发: 值[4x14B]格式

  // 系统信息
  mix_order_manufacturer = 0x00, // 制造商信息: 只读
  mix_order_build = 0x01, // 固件编译信息: 只写
  mix_order_save = 0x02, // 保存参数: 只写
  mix_order_reload = 0x03, // 重新加载参数: 只写
  mix_order_reset = 0x04, // 参数重置: 只写
  mix_order_factory = 0x05, // 恢复出厂设置: 只写, 超时>200ms

  // RGB控制
  mix_order_gray = 0x06, // RGB灰度: 可读写, GRAYx为RGB灰度
  mix_order_rgb_sub_gray = 0x16, // 侧灯亮度: arg(uint8_t) = 侧灯亮度(0-100)
  mix_order_rgb_sub_mode = 0x17, // 侧灯模式: arg(uint8_t) = 侧灯模式(0:OFF,1:ON,2:呼吸)
  mix_order_rgb_sub = 0x18, // 侧灯控制: arg1=亮度(0-100), arg2=模式
  mix_order_rgb_idx = 0x19, // 调色板索引: arg1(uint8_t) = 调色板索引[0-7]
  mix_order_rgb_mode = 0x1a, // 主键区灯光模式: arg1(uint8_t) = 灯光模式

  // 版本信息
  mix_order_query_ver_hex = 0x07, // 固件版本(HEX): 只读, 格式: 0x01,0x00,0x05
  mix_order_query_ver_str = 0x08, // 固件版本(字符串): 只读, 格式: "V1.0.05"
  mix_order_query_sn = 0x09, // 序列号: 只读, 16字节序列号
  mix_order_product_sn = 0x0a, // 厂商序列号: 可读写, 16字节序列号

  // 设备模式
  mix_order_quick = 0x10, // 快速模式: 可读写
  mix_order_ep_ticks = 0x11, // 回报率: 可读写
  mix_order_rgb_on = 0x12, // RGB开关: 可读写
  mix_order_rgb_back = 0x13, // 背光: 可读写
  mix_order_rgb_color = 0x14, // 调色板: 可读写
  mix_order_rgb_reverse = 0x15, // 反向: 可读写

  // 特殊模式
  mix_order_prod_line = 0x1b, // 生产线模式: arg=1开启/0关闭
  mix_order_quick_scan = 0x1c, // 快速扫描模式: arg=1开启/0关闭
  mix_order_dead_zone = 0x1d, // 自适应模式(死区): arg=1开启/0关闭

  // 查询/切换命令
  mix_order_qs_lookwin = 0x20, // 锁WIN键: 可查询/切换
  mix_order_qs_win = 0x21, // Win模式: 可查询/切换
  mix_order_qs_mac = 0x22, // Mac模式: 可查询/切换
  mix_order_qs_base = 0x23, // 标准模式: 可查询/切换
  mix_order_qs_linear = 0x24, // 可调行程模式: 可查询/切换
  mix_order_qs_rf = 0x25, // 工作模式: 可查询USB/2.4G/BLE模式
  mix_order_qs_sw = 0x26, // 波动开关档位: 可查询

  // 高级功能
  mix_order_auto_rp_hh = 0x30, // 自动上报: arg1=开启/关闭, arg2=上报延时
  mix_order_trigger = 0x31, // 触发: arg1=MM[1B], arg2=Reset[1B]
  mix_order_table = 0x32, // 参数组: arg1=Group[1,2,3,4]
  mix_order_adj_auto = 0x33, // 智能校准: arg1=0/1, 关闭/开启
  mix_order_adj_hand = 0x34, // 手动校准: arg1=0/1, 结束/开启/取消
}

/**
 * 创建写入命令
 * 将普通命令转换为写入命令（设置最高位为1）
 * @param cmd 原始命令
 * @returns 写入命令（最高位为1）
 */
export function OHID_CMD_WRITE(cmd: number): number {
  return 0x80 | (cmd & 0x7f)
}

/**
 * 获取原始命令
 * 从命令中提取原始命令（清除最高位）
 * @param cmd 包含读写位的命令
 * @returns 原始命令（清除最高位）
 */
export function OHID_CMD_GET(cmd: number): number {
  return cmd & 0x7f
}

// ============================================================
// 协议通用配置（Report ID / ACK 值等）
// ============================================================
export const PROTOCOL_CONFIG = {
  master_report_id: 0xaa,
  report_id: 0x00,
  busy_ack_value: 0x02, // 0x02 表示设备忙碌，需要重试
  read_ack_value: 0x01, // 0x01 表示读取成功
} as const

// ============================================================
// IAP 升级相关常量
// ============================================================
// 升级命令
